module.exports = __webpack_public_path__ + "static/media/teambuilder.8a1a6a17.svg";